/**
 * Test Personas for Local Development
 *
 * These personas map to real Cognito test accounts used for local UI validation.
 * Each persona has different route access levels in the financial aid system.
 */

export const TEST_PERSONAS = [
  {
    id: 'parent',
    label: 'Parent',
    description: 'Parent portal local validation account',
    email: 'e2e-parent@intelliolabs.com',
    icon: '\u{1F468}\u{200D}\u{1F469}\u{200D}\u{1F467}',
    color: '#228be6',
  },
  {
    id: 'staff',
    label: 'Staff Reviewer',
    description: 'Review applications, make decisions, generate reports',
    email: 'e2e-staff@intelliolabs.com',
    icon: '\u{1F4CB}',
    color: '#12b886',
  },
  {
    id: 'owner',
    label: 'Owner / Admin',
    description: 'Full admin access, appeals queue, system reports',
    email: 'e2e-owner@intelliolabs.com',
    icon: '\u{1F451}',
    color: '#be4bdb',
  },
] as const;

export type TestPersona = (typeof TEST_PERSONAS)[number];

export const TEST_PARENT_PERSONA_EMAIL =
  TEST_PERSONAS.find((persona) => persona.id === 'parent')?.email ??
  'e2e-parent@intelliolabs.com';

/**
 * Dev-only localStorage key for caching the shared test password used to
 * authenticate Cognito test personas during local validation runs.
 */
export const DEV_PERSONA_PASSWORD_KEY = 'ystnj-persona-password';
